<script setup lang="ts">
import { type Component } from 'vue'

const props = defineProps<{
  message: string
  icon?: Component
}>()
</script>
<template>
  <div
    class="font-mont-blanc-light -m-2 mb-2 flex h-[40px] items-center justify-center rounded-full bg-white p-4 px-7"
  >
    <component :is="props.icon" v-if="props.icon" class="mr-2 h-4 w-4" />
    {{ props.message }}
  </div>
</template>
